import React from "react";

export function HomeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
    >
      <path
        d="M9.33333 19.8333V12.8333H14V19.8333H19.8333V10.5H23.3333L11.6667 0L0 10.5H3.5V19.8333H9.33333Z"
        fill="#C4C4CD"
      />
    </svg>
  );
}
